export default __webpack_public_path__ + "static/media/adebambo.f453bee2.png";